'use client'

import type { Category } from '@/types/market'
import { useTranslations } from 'next-intl'
import type React from 'react'

interface EventCategoryBadgeProps {
	category: Category | string
}

const EventCategoryBadge: React.FC<EventCategoryBadgeProps> = ({ category }) => {
	const t = useTranslations('categories')

	// Map category to translation key
	const categoryKey = category as Category
	const translatedCategory = t(categoryKey)

	return (
		<p className="m-0 inline-block w-auto rounded-[6px] bg-white/5 px-[6px] py-[3px] text-[10px] leading-[100%]">
			{translatedCategory}
		</p>
	)
}

export default EventCategoryBadge
